import { Currency, Locale } from '@synergy/models';
import { unique } from '@synergy/utils';

import { ShoppingCart, ShoppingCartItemStatus, ShoppingCartSupplier } from '../shopping-cart';
import { ShoppingCartDto } from '../dto/shopping-cart-dto';
import { mapAddress } from './address-mapper';
import { mapShoppingCartSupplier } from './shopping-cart-supplier-mapper';

export const mapShoppingCart = (
    shoppingCart: ShoppingCartDto,
    locales: Locale[],
    currency: Currency
): ShoppingCart | null => {
    const suppliers = shoppingCart.suppliers.map(supplier => mapShoppingCartSupplier(supplier, locales, currency));
    if (suppliers.some(supplier => supplier === null)) {
        return null;
    }

    return {
        invoiceAddress: shoppingCart.invoiceAddress && mapAddress(shoppingCart.invoiceAddress),
        deliveryAddress: shoppingCart.deliveryAddress && mapAddress(shoppingCart.deliveryAddress),
        avisoContact: shoppingCart.avisoContact,
        desiredDeliveryDate: shoppingCart.desiredDeliveryDate ? new Date(shoppingCart.desiredDeliveryDate) : null,
        costCentre: shoppingCart.costCentre ?? '',
        perOrderOrderLimit: shoppingCart.perOrderOrderLimit,
        monthlyOrderLimit: shoppingCart.monthlyOrderLimit,
        currentMonthlyOrderSum: shoppingCart.currentMonthlyOrderSum ?? 0,
        suppliers: suppliers as ShoppingCartSupplier[],
        itemStatuses: unique(suppliers.map(supplier => supplier?.items.map(item => item.status)).flat()).filter(
            (x): x is ShoppingCartItemStatus => x !== null
        ),
    };
};
